if (!customElements.get("details-disclosure")) {
  customElements.define(
    "details-disclosure",
    class DetailsDisclosure extends HTMLElement {
      constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.summary = this.mainDetailsToggle.querySelector("summary");
        this.content = this.summary.nextElementSibling;
        //this.setContentHeight();
        this.bindEvents();
      }

      bindEvents() {
        this.summary.addEventListener("click", this.onToggle.bind(this));
      }

      getTotalChildrenHeight(parent) {
        let totalHeight = 0;
        const children = parent.children;
        console.log(children)

        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          const childHeight = child.offsetHeight;
          totalHeight += childHeight;
        }

        return totalHeight;
      }

      setContentHeight() {
        this.content.style.setProperty(
          "--content-height",
          `${this.getTotalChildrenHeight(this.content)}px`
        );
      }

      onToggle(event) {
        event.preventDefault();
        if (!this.mainDetailsToggle.hasAttribute("open")) {
          this.mainDetailsToggle.setAttribute("open", true);
          this.setContentHeight();
          setTimeout(() => {
            this.mainDetailsToggle.classList.add("active");
          });
        } else {
          this.setContentHeight();
          setTimeout(() => {
            this.mainDetailsToggle.classList.remove("active");
            setTimeout(() => {
              this.mainDetailsToggle.removeAttribute("open");
            }, 250);
          });
        }
      }
    }
  );
}
